module.exports = __webpack_public_path__ + "img/bg_slogan@2x.92a65b60.png";